import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Trash2, Clock } from 'lucide-react';

const History = () => {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('ai_assistant_history') || '[]');
    setHistory(stored);
  }, []);

  const clearHistory = () => {
    if (window.confirm('Clear all history?')) {
      localStorage.removeItem('ai_assistant_history');
      setHistory([]);
    }
  };

  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleString();
  };

  const stripHtml = (html) => html.replace(/<[^>]+>/g, '').trim();

  return (
    <div style={{ padding: '1.5rem 2rem', maxWidth: '1000px', margin: '0 auto' }}>
      {/* Back */}
      <button
        onClick={() => navigate('/ai-assistant')}
        style={{
          display: 'flex', alignItems: 'center', gap: '0.4rem',
          background: 'none', border: 'none', color: '#6b7280',
          cursor: 'pointer', fontSize: '0.875rem', fontWeight: 600,
          marginBottom: '1.25rem', padding: 0,
        }}
        onMouseEnter={e => e.currentTarget.style.color = '#16a34a'}
        onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}
      >
        <ArrowLeft size={16} /> Back to AI Assistant
      </button>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <Clock size={22} color="#16a34a" />
          <h1 style={{ margin: 0, fontSize: '1.35rem', fontWeight: 800, color: '#111827' }}>Generation History</h1>
        </div>
        {history.length > 0 && (
          <button
            onClick={clearHistory}
            style={{
              display: 'flex', alignItems: 'center', gap: '0.4rem',
              background: '#fef2f2', color: '#b91c1c',
              border: '1px solid #fecaca', borderRadius: '7px',
              padding: '0.45rem 1rem', fontSize: '0.85rem',
              fontWeight: 600, cursor: 'pointer',
            }}
          >
            <Trash2 size={14} /> Clear All
          </button>
        )}
      </div>

      {history.length === 0 ? (
        <div style={{
          background: '#fff', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
          border: '1px solid #f0f0f0', padding: '3rem',
          textAlign: 'center', color: '#9ca3af',
        }}>
          <Clock size={40} color="#d1d5db" style={{ marginBottom: '0.75rem' }} />
          <p style={{ margin: 0, fontSize: '0.95rem' }}>No history yet. Start generating content!</p>
          <button
            onClick={() => navigate('/ai-assistant')}
            style={{
              marginTop: '1rem', background: '#16a34a', color: '#fff',
              border: 'none', borderRadius: '7px', padding: '0.55rem 1.5rem',
              fontSize: '0.875rem', fontWeight: 600, cursor: 'pointer',
            }}
          >
            Go to AI Assistant
          </button>
        </div>
      ) : (
        <div style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
            <thead>
              <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                <th style={{ padding: '0.85rem 1rem', textAlign: 'left', fontWeight: 700, color: '#374151' }}>#</th>
                <th style={{ padding: '0.85rem 1rem', textAlign: 'left', fontWeight: 700, color: '#374151' }}>Date</th>
                <th style={{ padding: '0.85rem 1rem', textAlign: 'left', fontWeight: 700, color: '#374151' }}>Tool</th>
                <th style={{ padding: '0.85rem 1rem', textAlign: 'left', fontWeight: 700, color: '#374151' }}>Tokens</th>
                <th style={{ padding: '0.85rem 1rem', textAlign: 'left', fontWeight: 700, color: '#374151' }}>Output Preview</th>
                <th style={{ padding: '0.85rem 1rem', textAlign: 'left', fontWeight: 700, color: '#374151' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {history.map((item, index) => (
                <React.Fragment key={item.id}>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: index % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ padding: '0.85rem 1rem', color: '#9ca3af', fontWeight: 600 }}>{index + 1}</td>
                    <td style={{ padding: '0.85rem 1rem', color: '#6b7280', whiteSpace: 'nowrap' }}>{formatDate(item.date)}</td>
                    <td style={{ padding: '0.85rem 1rem' }}>
                      <span style={{
                        background: '#f0fdf4', color: '#16a34a',
                        border: '1px solid #bbf7d0', borderRadius: '20px',
                        padding: '0.2rem 0.65rem', fontSize: '0.78rem', fontWeight: 600,
                      }}>
                        {item.tool}
                      </span>
                    </td>
                    <td style={{ padding: '0.85rem 1rem', color: '#6b7280' }}>{item.tokens_used || '—'}</td>
                    <td style={{ padding: '0.85rem 1rem', color: '#374151', maxWidth: '300px' }}>
                      <span style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                        {stripHtml(item.output).substring(0, 120)}...
                      </span>
                    </td>
                    <td style={{ padding: '0.85rem 1rem' }}>
                      <button
                        onClick={() => setExpanded(expanded === item.id ? null : item.id)}
                        style={{
                          background: expanded === item.id ? '#f0fdf4' : '#f9fafb',
                          color: expanded === item.id ? '#16a34a' : '#374151',
                          border: `1px solid ${expanded === item.id ? '#bbf7d0' : '#e5e7eb'}`,
                          borderRadius: '6px', padding: '0.35rem 0.75rem',
                          fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
                        }}
                      >
                        {expanded === item.id ? 'Collapse' : 'View'}
                      </button>
                    </td>
                  </tr>
                  {expanded === item.id && (
                    <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                      <td colSpan={6} style={{ padding: '1rem 1.5rem', background: '#f9fafb' }}>
                        <div style={{ fontSize: '0.82rem', color: '#6b7280', marginBottom: '0.5rem', fontWeight: 600 }}>Full Output:</div>
                        <div
                          style={{
                            background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px',
                            padding: '1rem', fontSize: '0.875rem', lineHeight: 1.7, color: '#111827',
                          }}
                          dangerouslySetInnerHTML={{ __html: item.output }}
                        />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default History;
